/** @format */

import axios from "axios";
// import { useSelector } from "react-redux";
// import { notifyFailure, notifySuccess } from "../components/toast";
import {
  USER_AUTH_REQUEST,
  USER_AUTH_SUCCESS,
  USER_AUTH_FAIL,
  //   COMPANY_AUTH_REQUEST,
  //   COMPANY_AUTH_SUCCESS,
  //   COMPANY_AUTH_FAIL,
  USER_LOGOUT_SUCCESS,
  USER_LOGOUT_FAIL,
  GET_USER_FAIL,
  GET_USER_REQUEST,
  GET_USER_SUCCESS,
  SERVERADDRESS,
} from "../constants";
// import { navigateUserFunc } from "./generalActions";

// USER LOGIN
export const userLogin = (obj, navigate, returnUrl) => async (dispatch) => {
  dispatch({
    type: USER_AUTH_REQUEST,
  });
  try {
    const { data } = await axios.post(`${SERVERADDRESS}/v1/auth/login`, obj);
    localStorage.setItem("tokens", JSON.stringify(data.tokens));
    localStorage.setItem("user", JSON.stringify(data.user));
    dispatch({
      type: USER_AUTH_SUCCESS,
      payload: data,
    });
    data.user.role === "admin" || data.user.role === "superAdmin"
      ? navigate("/dashboard")
      : data.user.role === "user" && returnUrl
      ? navigate(returnUrl)
      : navigate("/");
    // navigate("/checkout");

    // navigate("/dashboard");
    // navigateUserFunc(data.user, navigate);
  } catch (err) {
    dispatch({
      type: USER_AUTH_FAIL,
      payload: err,
    });
  }
};

//USER LOGOUT
export const userLogout =
  (obj, navigateUser, idAdminLoginInfo) => async (dispatch) => {
    try {
      await axios.post(`${SERVERADDRESS}/v1/auth/logout`, obj);
      localStorage.removeItem("tokens");
      localStorage.removeItem("user");
      if (idAdminLoginInfo) {
        await axios.put(
          `${SERVERADDRESS}/v1/userLoginInfo/updateUserLoginInfo`,
          {
            _id: idAdminLoginInfo,
            loginStatus: false,
          }
        );
      }
      dispatch({
        type: USER_LOGOUT_SUCCESS,
      });
      localStorage.clear();
      if (navigateUser) {
        navigateUser();
      }
    } catch (err) {
      console.log(err, "err");
      dispatch({
        type: USER_LOGOUT_FAIL,
        payload: err.response.data.message,
      });
      localStorage.clear();
      navigateUser();
    }
  };

// export const getUserByToken = (token, navigate, auth) => async (dispatch) => {
//   navigate("/checkUser");
//   dispatch({
//     type: GET_USER_REQUEST,
//   });
//   try {
//     const { data } = await axios.post(
//       `${SERVERADDRESS}/v1/auth/refresh-tokens`,
//       {
//         refreshToken: token,
//       }
//     );
//     localStorage.setItem("tokens", JSON.stringify(data));
//     dispatch({
//       type: GET_USER_SUCCESS,
//       payload: data,
//     });
//     if (auth?.user?.permissionId?.dashboard?.isAllow === true) {
//       navigate("/dashboard-admin");
//     } else if (auth?.user?.permissionId?.dashboardDriver?.isAllow === true) {
//       navigate("/dashboard-driver");
//     } else if (
//       auth?.user?.permissionId?.dashboardDispatcher?.isAllow === true
//     ) {
//       navigate("/dashboard-dispatcher");
//     } else if (
//       auth?.user?.isExternalCompany === true ||
//       auth?.user?.isClient === true
//     ) {
//       navigate("/dashboard");
//     }
//   } catch (err) {
//     dispatch({
//       type: GET_USER_FAIL,
//       payload: err?.response?.data?.message,
//     });
//     navigate("/login");
//     localStorage.clear();
//       }
// };

export const userCustLogin = (obj, navigate) => async (dispatch) => {
  dispatch({
    type: USER_AUTH_REQUEST,
  });
  try {
    const { data } = await axios.post(`${SERVERADDRESS}/v1/auth/login`, obj);
    localStorage.setItem("tokens", JSON.stringify(data.tokens));
    localStorage.setItem("user", JSON.stringify(data.user));
    dispatch({
      type: USER_AUTH_SUCCESS,
      payload: data,
    });
    navigate("/checkout");
    // navigateUserFunc(data.user, navigate);
  } catch (err) {
    dispatch({
      type: USER_AUTH_FAIL,
      payload: err,
    });
  }
};
